import React from 'react';

const ElectronicMedia = () => {
  return (
    <div>
      ElectronicMedia
      ElectronicMedia
    </div>
  );
}

export default ElectronicMedia;
